import React from 'react'
import RotateLeftRoundedIcon from '@mui/icons-material/RotateLeftRounded'
import GenericButton from '../../../components/GenericButton'
import { useFormContext, useWatch } from 'react-hook-form'
import { Box } from '@mui/material'
import { OptionalLabel } from '../../SurveyFeature/styles'

interface QuestionHeaderProps {
  onChange?: (value: string) => void
  name: string
  isRequired: boolean
}

const QuestionHeader: React.FC<QuestionHeaderProps> = ({ onChange, name, isRequired }) => {
  const { setValue } = useFormContext()
  const submitedValue = useWatch({ name })
  const showResetButton = Array.isArray(submitedValue) ? submitedValue?.length > 0 : submitedValue

  const handleReset = (): void => {
    onChange?.('')
    setValue(name, '')
  }

  return (
    <Box display={'flex'} justifyContent={isRequired ? 'space-between' : 'flex-end'} alignItems={'center'} height={'16px'} mb={3} >
      {isRequired && <OptionalLabel>Required</OptionalLabel> }
      {showResetButton && onChange &&
        <GenericButton
        title='Reset Answer'
          style={{ padding: 0 }}
          icon={<RotateLeftRoundedIcon />}
          onClick={handleReset}
        />
      }
    </Box>

  )
}

export default QuestionHeader
